import React from 'react';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';

const RadioCheckOption = ({
        radioOptionValues, callBckFn, defaultSelect, classname, radiostyle
    }) => {
    const handleRadioCheck = (e) => {
        const { value } = e.target;
        if (defaultSelect === value) {
            callBckFn('');
        } else {
            callBckFn(value);
        }
    };

    const loadRadioOptions = (data) => {
        return (
            data.map((i) => (
                <label id={v4()} key={v4()} className={radiostyle} htmlFor={i.htmlFor}>
                    {i.title}
                    <input
                      type="radio"
                      id={i.htmlFor}
                      name={i.name}
                      value={i.mainValue}
                      readOnly
                      onClick={handleRadioCheck}
                      onKeyDown={(e) => e.preventDefault()}
                      checked={i.mainValue === defaultSelect}
                    />
                    <span className="checkmark"> </span>
                </label>
            ))
        );
    };

    return (
        <>
            <div id={v4()} className={classname}>
                {
                    loadRadioOptions(radioOptionValues)
                }
            </div>
        </>
    );
};

RadioCheckOption.propTypes = {
    callBckFn: PropTypes.func.isRequired,
    classname: PropTypes.string.isRequired,
    defaultSelect: PropTypes.string,
    radioOptionValues: PropTypes.arrayOf(PropTypes.shape({
        htmlFor: PropTypes.string.isRequired,
        mainValue: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
      })).isRequired,
    radiostyle: PropTypes.string.isRequired
};

export default RadioCheckOption;
